import type { AreaDict } from '../messages'

// Tela de Orçamento (BudgetPage) + editor de predefinidos (PresetDialog).
// pt-BR = textos atuais do app; en/es fiéis.
const budget: AreaDict = {
  'pt-BR': {
    'bud.title': 'Orçamento',
    'bud.preset': 'Predefinir',
    'bud.applyPresets': 'Aplicar predefinidos',
    'bud.copyPrev': 'Copiar do mês anterior',
    'bud.adjust': 'Ajuste',
    'bud.adjustTooltip':
      'Alinha o orçado ao consumido em {month} (só neste mês): cria o orçamento onde não há e sobe onde o consumido passou (automático). Também pode reduzir onde sobrou — mas só as categorias que você marcar.',
    'bud.prevMonth': 'Mês anterior',
    'bud.nextMonth': 'Próximo mês',
    'bud.monthDespesaSummary': 'Despesa orçada {budgeted} · consumida {consumed}',
    'bud.backToCurrent': 'Voltar ao mês atual',
    'bud.summaryIncome': 'Receitas (recebido / orçado)',
    'bud.incomeRecTooltip':
      'Recorrentes do mês ainda não lançados — contam no Resultado, mas não caíram na conta.',
    'bud.plusToReceive': '+ a receber',
    'bud.summaryExpense': 'Despesas (consumido / orçado)',
    'bud.investTooltip':
      'Resultado líquido dos investimentos/day-trade no mês (ganhos − perdas). Positivo = ganho, negativo = perda. Entra no Resultado com esse sinal, fora das Despesas.',
    'bud.investments': 'Investimentos',
    'bud.includesToPost': 'inclui a lançar',
    'bud.resultTooltip':
      'Real = (recebido + a receber) − (consumido + a lançar) + resultado de investimentos. Previsto = receita − despesa ORÇADA + resultado REAL de investimentos (day-trade não é orçado). Os dois incluem a sobra herdada e a variação cambial.',
    'bud.resultLabel': 'Resultado (real / previsto)',
    'bud.plusRollover': ' + sobra',
    'bud.fxTooltip':
      'Custo real do câmbio nas transferências entre moedas do mês: o que saiu menos o que chegou, ambos pela cotação de hoje (spread + tarifas).',
    'bud.includesFx': 'inclui variação cambial (transferências)',
    'bud.revalTooltip':
      'Diferença entre a cotação de hoje e a taxa congelada nos lançamentos em outras moedas. Não é dinheiro realizado — só mantém a sobra herdada batendo com o saldo das contas.',
    'bud.includesReval': 'reavaliação pela cotação',
    'bud.includeRollover': 'Incluir sobra do mês anterior:',
    'bud.category': 'Categoria',
    'bud.budget': 'Orçamento',
    'bud.income': 'Receitas',
    'bud.expenses': 'Despesas',
    'bud.received': 'Recebido',
    'bud.toReceiveCol': 'A receber',
    'bud.difference': 'Diferença',
    'bud.consumed': 'Consumido',
    'bud.toPost': 'A lançar',
    'bud.available': 'Disponível',
    'bud.pendingColTooltip':
      'Recorrentes do mês que ainda NÃO viraram transação. Entram no resultado do mês, mas não foram recebidos/gastos ainda.',
    'bud.viewPosted': 'Ver itens lançados',
    'bud.useTotalAsBudget': 'Usar o total (lançado + recorrente) como orçamento',
    'bud.viewRecurringNotPosted': 'Ver recorrentes ainda não lançados',
    'bud.recurringOf': '{name} — recorrentes',
    'bud.define': 'definir',
    'bud.noCategory': 'Sem categoria',
    'bud.viewNoCategory': 'Ver itens sem categoria',
    'bud.categorizeToBudget': 'categorize para orçar',
    'bud.viewPostedGroup': 'Ver itens lançados do grupo',
    'bud.viewRecurringGroup': 'Ver recorrentes do grupo ainda não lançados',
    'bud.general': '{name} (geral)',
    'bud.emptyTitle': 'Nenhuma categoria ainda',
    'bud.emptyDesc':
      'Crie categorias de receita e despesa para poder definir um orçamento por categoria. Assim que existirem categorias, elas aparecem aqui para você orçar.',
    'bud.detailSummary': '{count} itens · {month} · total {total}',
    'bud.tagPending': 'pendente',
    'bud.tagRecurring': 'recorrente',
    'bud.noDescription': '(sem descrição)',
    'bud.recurringPlaceholder': '(recorrente)',
    'bud.toastSaved': 'Orçamento salvo',
    'bud.toastSaveError': 'Erro ao salvar orçamento',
    'bud.toastCopied': '{n} orçamento(s) copiado(s) do mês anterior',
    'bud.toastCopyEmpty': 'O mês anterior não tem orçamentos',
    'bud.toastCopyError': 'Erro ao copiar',
    'bud.toastPresetsApplied': '{n} predefinido(s) aplicado(s) em {month}',
    'bud.toastPresetsEmpty': 'Nenhum predefinido salvo ainda',
    'bud.toastApplyError': 'Erro ao aplicar',
    'bud.toastNothingToAdjust': 'Nada a ajustar: orçado e consumido já batem em todas as categorias.',
    'bud.adjustConfirmTitle': 'Ajustar {total} categoria(s)?',
    'bud.adjustDialogTitle': 'Ajustar orçamento — {month}',
    'bud.adjustDialogDesc':
      'Categorias sem orçamento ou estouradas são ajustadas automaticamente. Categorias com sobra só são reduzidas se você marcar cada uma.',
    'bud.adjustSemOrcPre': 'com consumido mas',
    'bud.adjustSemOrcBold': 'sem orçamento',
    'bud.adjustSemOrcPost': '— o orçamento será criado com o valor consumido.',
    'bud.adjustEstourouPre': 'com consumido',
    'bud.adjustEstourouBold': 'acima do orçado',
    'bud.adjustEstourouPost': '— o orçamento sobe para o consumido.',
    'bud.adjustTotalIncrease': 'Aumento total do orçamento:',
    'bud.adjustConfirm': 'Ajustar',
    'bud.adjustConfirmN': 'Aplicar ({n})',
    'bud.adjustZeradosTitle': 'Sem nenhum consumo (zerados)',
    'bud.adjustZeradosHint':
      'Nada foi gasto ainda — o orçado pode ser uma reserva para algo que ainda vai acontecer. Marque só se tiver certeza que não vai usar.',
    'bud.adjustSobrouTitle': 'Com diferença (sobrou parte)',
    'bud.adjustSobrouHint': 'Já teve algum consumo, mas sobrou orçado. Marque as que quer reduzir ao consumido.',
    'bud.adjustSelectAll': 'marcar todas',
    'bud.adjustUnselectAll': 'desmarcar todas',
    'bud.adjustReduceTotal': 'Redução selecionada:',
    'bud.toastAdjusted': '{n} orçamento(s) ajustado(s) ao consumido',
    'bud.toastAdjustError': 'Erro ao ajustar',
    'bud.presetSaveError': 'Erro ao salvar',
    'bud.presetsTitle': 'Orçamentos predefinidos',
    'bud.presetsDesc': 'Defina um valor padrão por categoria. Depois use “Aplicar predefinidos” em cada mês.',
    'bud.presetValue': 'Valor predefinido',
  },
  en: {
    'bud.title': 'Budget',
    'bud.preset': 'Presets',
    'bud.applyPresets': 'Apply presets',
    'bud.copyPrev': 'Copy from previous month',
    'bud.adjust': 'Adjust',
    'bud.adjustTooltip':
      'Aligns the budget to what was consumed in {month} (this month only): creates a budget where there is none and raises it where consumption exceeded it (automatic). Can also reduce where there was leftover — but only for the categories you check.',
    'bud.prevMonth': 'Previous month',
    'bud.nextMonth': 'Next month',
    'bud.monthDespesaSummary': 'Budgeted expense {budgeted} · consumed {consumed}',
    'bud.backToCurrent': 'Back to current month',
    'bud.summaryIncome': 'Income (received / budgeted)',
    'bud.incomeRecTooltip':
      'Recurring items for the month not yet posted — they count toward the Result, but haven’t hit the account.',
    'bud.plusToReceive': '+ to receive',
    'bud.summaryExpense': 'Expenses (consumed / budgeted)',
    'bud.investTooltip':
      'Net result of investments/day-trading for the month (gains − losses). Positive = gain, negative = loss. Enters the Result with that sign, outside Expenses.',
    'bud.investments': 'Investments',
    'bud.includesToPost': 'includes to post',
    'bud.resultTooltip':
      'Real = (received + to receive) − (consumed + to post) + investment result. Forecast = income − BUDGETED expense + REAL investment result (day-trading isn’t budgeted). Both include the inherited rollover and the FX variation.',
    'bud.resultLabel': 'Result (real / forecast)',
    'bud.plusRollover': ' + rollover',
    'bud.fxTooltip':
      'Real FX cost of the month’s cross-currency transfers: what left minus what arrived, both at today’s rate (spread + fees).',
    'bud.includesFx': 'includes FX variation (transfers)',
    'bud.revalTooltip':
      'Difference between today’s rate and the rate frozen on entries in other currencies. Not realized money — it only keeps the inherited rollover matching the account balances.',
    'bud.includesReval': 'revaluation at current rate',
    'bud.includeRollover': 'Include previous month’s rollover:',
    'bud.category': 'Category',
    'bud.budget': 'Budget',
    'bud.income': 'Income',
    'bud.expenses': 'Expenses',
    'bud.received': 'Received',
    'bud.toReceiveCol': 'To receive',
    'bud.difference': 'Difference',
    'bud.consumed': 'Consumed',
    'bud.toPost': 'To post',
    'bud.available': 'Available',
    'bud.pendingColTooltip':
      'Recurring items for the month that have NOT yet become a transaction. They count toward the month’s result, but haven’t been received/spent yet.',
    'bud.viewPosted': 'View posted items',
    'bud.useTotalAsBudget': 'Use the total (posted + recurring) as budget',
    'bud.viewRecurringNotPosted': 'View recurring items not yet posted',
    'bud.recurringOf': '{name} — recurring',
    'bud.define': 'set',
    'bud.noCategory': 'No category',
    'bud.viewNoCategory': 'View items without category',
    'bud.categorizeToBudget': 'categorize to budget',
    'bud.viewPostedGroup': 'View posted items in the group',
    'bud.viewRecurringGroup': 'View group recurring items not yet posted',
    'bud.general': '{name} (general)',
    'bud.emptyTitle': 'No categories yet',
    'bud.emptyDesc':
      'Create income and expense categories to be able to set a budget per category. Once categories exist, they appear here for you to budget.',
    'bud.detailSummary': '{count} items · {month} · total {total}',
    'bud.tagPending': 'pending',
    'bud.tagRecurring': 'recurring',
    'bud.noDescription': '(no description)',
    'bud.recurringPlaceholder': '(recurring)',
    'bud.toastSaved': 'Budget saved',
    'bud.toastSaveError': 'Error saving budget',
    'bud.toastCopied': '{n} budget(s) copied from the previous month',
    'bud.toastCopyEmpty': 'The previous month has no budgets',
    'bud.toastCopyError': 'Error copying',
    'bud.toastPresetsApplied': '{n} preset(s) applied in {month}',
    'bud.toastPresetsEmpty': 'No presets saved yet',
    'bud.toastApplyError': 'Error applying',
    'bud.toastNothingToAdjust': 'Nothing to adjust: budget and consumption already match in every category.',
    'bud.adjustConfirmTitle': 'Adjust {total} category(ies)?',
    'bud.adjustDialogTitle': 'Adjust budget — {month}',
    'bud.adjustDialogDesc':
      'Categories with no budget or that ran over are adjusted automatically. Categories with leftover are only reduced if you check each one.',
    'bud.adjustSemOrcPre': 'with consumption but',
    'bud.adjustSemOrcBold': 'no budget',
    'bud.adjustSemOrcPost': '— the budget will be created with the consumed value.',
    'bud.adjustEstourouPre': 'with consumption',
    'bud.adjustEstourouBold': 'above budget',
    'bud.adjustEstourouPost': '— the budget rises to the consumed value.',
    'bud.adjustTotalIncrease': 'Total budget increase:',
    'bud.adjustConfirm': 'Adjust',
    'bud.adjustConfirmN': 'Apply ({n})',
    'bud.adjustZeradosTitle': 'No consumption at all (zeroed)',
    'bud.adjustZeradosHint':
      'Nothing was spent yet — the budget may be a reserve for something that hasn’t happened. Only check if you’re sure it won’t be used.',
    'bud.adjustSobrouTitle': 'With a difference (partial leftover)',
    'bud.adjustSobrouHint': 'Some spending already happened, but budget is left over. Check the ones you want to reduce to the consumed value.',
    'bud.adjustSelectAll': 'select all',
    'bud.adjustUnselectAll': 'unselect all',
    'bud.adjustReduceTotal': 'Selected reduction:',
    'bud.toastAdjusted': '{n} budget(s) adjusted to consumption',
    'bud.toastAdjustError': 'Error adjusting',
    'bud.presetSaveError': 'Error saving',
    'bud.presetsTitle': 'Preset budgets',
    'bud.presetsDesc': 'Set a default value per category. Then use “Apply presets” each month.',
    'bud.presetValue': 'Preset value',
  },
  es: {
    'bud.title': 'Presupuesto',
    'bud.preset': 'Predefinir',
    'bud.applyPresets': 'Aplicar predefinidos',
    'bud.copyPrev': 'Copiar del mes anterior',
    'bud.adjust': 'Ajuste',
    'bud.adjustTooltip':
      'Alinea lo presupuestado con lo consumido en {month} (solo este mes): crea el presupuesto donde no hay y lo sube donde el consumo lo superó (automático). También puede reducirlo donde sobró — pero solo en las categorías que marques.',
    'bud.prevMonth': 'Mes anterior',
    'bud.nextMonth': 'Mes siguiente',
    'bud.monthDespesaSummary': 'Gasto presupuestado {budgeted} · consumido {consumed}',
    'bud.backToCurrent': 'Volver al mes actual',
    'bud.summaryIncome': 'Ingresos (recibido / presupuestado)',
    'bud.incomeRecTooltip':
      'Recurrentes del mes aún no registrados — cuentan en el Resultado, pero no han entrado en la cuenta.',
    'bud.plusToReceive': '+ por recibir',
    'bud.summaryExpense': 'Gastos (consumido / presupuestado)',
    'bud.investTooltip':
      'Resultado neto de las inversiones/day-trade del mes (ganancias − pérdidas). Positivo = ganancia, negativo = pérdida. Entra en el Resultado con ese signo, fuera de los Gastos.',
    'bud.investments': 'Inversiones',
    'bud.includesToPost': 'incluye por registrar',
    'bud.resultTooltip':
      'Real = (recibido + por recibir) − (consumido + por registrar) + resultado de inversiones. Previsto = ingresos − gasto PRESUPUESTADO + resultado REAL de inversiones (el day-trade no se presupuesta). Ambos incluyen el sobrante heredado y la variación cambiaria.',
    'bud.resultLabel': 'Resultado (real / previsto)',
    'bud.plusRollover': ' + sobrante',
    'bud.fxTooltip':
      'Costo real del cambio en las transferencias entre monedas del mes: lo que salió menos lo que llegó, ambos a la cotización de hoy (spread + comisiones).',
    'bud.includesFx': 'incluye variación cambiaria (transferencias)',
    'bud.revalTooltip':
      'Diferencia entre la cotización de hoy y la tasa congelada en movimientos en otras monedas. No es dinero realizado — solo mantiene el sobrante heredado cuadrando con el saldo de las cuentas.',
    'bud.includesReval': 'revaluación por cotización',
    'bud.includeRollover': 'Incluir el sobrante del mes anterior:',
    'bud.category': 'Categoría',
    'bud.budget': 'Presupuesto',
    'bud.income': 'Ingresos',
    'bud.expenses': 'Gastos',
    'bud.received': 'Recibido',
    'bud.toReceiveCol': 'Por recibir',
    'bud.difference': 'Diferencia',
    'bud.consumed': 'Consumido',
    'bud.toPost': 'Por registrar',
    'bud.available': 'Disponible',
    'bud.pendingColTooltip':
      'Recurrentes del mes que aún NO se convirtieron en transacción. Cuentan en el resultado del mes, pero todavía no se recibieron/gastaron.',
    'bud.viewPosted': 'Ver ítems registrados',
    'bud.useTotalAsBudget': 'Usar el total (registrado + recurrente) como presupuesto',
    'bud.viewRecurringNotPosted': 'Ver recurrentes aún no registrados',
    'bud.recurringOf': '{name} — recurrentes',
    'bud.define': 'definir',
    'bud.noCategory': 'Sin categoría',
    'bud.viewNoCategory': 'Ver ítems sin categoría',
    'bud.categorizeToBudget': 'categoriza para presupuestar',
    'bud.viewPostedGroup': 'Ver ítems registrados del grupo',
    'bud.viewRecurringGroup': 'Ver recurrentes del grupo aún no registrados',
    'bud.general': '{name} (general)',
    'bud.emptyTitle': 'Aún no hay categorías',
    'bud.emptyDesc':
      'Crea categorías de ingresos y gastos para poder definir un presupuesto por categoría. En cuanto existan categorías, aparecerán aquí para que las presupuestes.',
    'bud.detailSummary': '{count} ítems · {month} · total {total}',
    'bud.tagPending': 'pendiente',
    'bud.tagRecurring': 'recurrente',
    'bud.noDescription': '(sin descripción)',
    'bud.recurringPlaceholder': '(recurrente)',
    'bud.toastSaved': 'Presupuesto guardado',
    'bud.toastSaveError': 'Error al guardar el presupuesto',
    'bud.toastCopied': '{n} presupuesto(s) copiado(s) del mes anterior',
    'bud.toastCopyEmpty': 'El mes anterior no tiene presupuestos',
    'bud.toastCopyError': 'Error al copiar',
    'bud.toastPresetsApplied': '{n} predefinido(s) aplicado(s) en {month}',
    'bud.toastPresetsEmpty': 'Aún no hay predefinidos guardados',
    'bud.toastApplyError': 'Error al aplicar',
    'bud.toastNothingToAdjust': 'Nada que ajustar: presupuestado y consumido ya coinciden en todas las categorías.',
    'bud.adjustConfirmTitle': '¿Ajustar {total} categoría(s)?',
    'bud.adjustDialogTitle': 'Ajustar presupuesto — {month}',
    'bud.adjustDialogDesc':
      'Las categorías sin presupuesto o excedidas se ajustan automáticamente. Las categorías con sobrante solo se reducen si marcas cada una.',
    'bud.adjustSemOrcPre': 'con consumido pero',
    'bud.adjustSemOrcBold': 'sin presupuesto',
    'bud.adjustSemOrcPost': '— el presupuesto se creará con el valor consumido.',
    'bud.adjustEstourouPre': 'con consumido',
    'bud.adjustEstourouBold': 'por encima del presupuesto',
    'bud.adjustEstourouPost': '— el presupuesto sube al valor consumido.',
    'bud.adjustTotalIncrease': 'Aumento total del presupuesto:',
    'bud.adjustConfirm': 'Ajustar',
    'bud.adjustConfirmN': 'Aplicar ({n})',
    'bud.adjustZeradosTitle': 'Sin ningún consumo (en cero)',
    'bud.adjustZeradosHint':
      'Aún no se gastó nada — el presupuesto puede ser una reserva para algo que todavía va a pasar. Marca solo si estás seguro de que no se va a usar.',
    'bud.adjustSobrouTitle': 'Con diferencia (sobró parte)',
    'bud.adjustSobrouHint': 'Ya hubo algo de consumo, pero sobró presupuesto. Marca las que quieras reducir al valor consumido.',
    'bud.adjustSelectAll': 'marcar todas',
    'bud.adjustUnselectAll': 'desmarcar todas',
    'bud.adjustReduceTotal': 'Reducción seleccionada:',
    'bud.toastAdjusted': '{n} presupuesto(s) ajustado(s) al consumido',
    'bud.toastAdjustError': 'Error al ajustar',
    'bud.presetSaveError': 'Error al guardar',
    'bud.presetsTitle': 'Presupuestos predefinidos',
    'bud.presetsDesc': 'Define un valor predeterminado por categoría. Luego usa «Aplicar predefinidos» en cada mes.',
    'bud.presetValue': 'Valor predefinido',
  },
}

export default budget
